import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource"; 

type Entity = models.SobrePendienteDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas : Column[] = [
    {title: "Guia", cell: x => ({data: x.FolioGuia })},
    {title: "Numero", cell: x => ({data: `${x.NumeroFisico}/${x.CantidadTotal}` })},
    {title: "Contenido", cell: x => ({data: x.Contenido })},
];

export interface BotonesDeps {
    onQuitar: (x: Entity) => void | Promise<void>;
}


/**Obtiene las columnas del grid */
export function columnas(deps:BotonesDeps) : Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("trash"),
            style:"danger",
            tooltip: "Quitar sobre",
            onClick: deps.onQuitar
        }
    ]);

    return [botones, ... columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/componentes/cargas/pendientes/sobres/columns.tsx